module.exports = __webpack_public_path__ + "static/media/studentCard1.5d644168.jpg";